<template>
  <div @click="toggle" v-on-clickaway="away" class="dropdown">
    <slot name="toggler"></slot>
    <slot/>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'Dropdown',
  mixins: [clickaway],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      sharedState: this.sharedState,
    };
  },
  data() {
    return {
      sharedState: {
        active: false,
      },
    };
  },
  methods: {
    toggle() {
      if (this.disabled) {
        this.sharedState.active = false;
      } else {
        this.sharedState.active = !this.sharedState.active;
      }
    },
    away() {
      this.sharedState.active = false;
    },
  },
};
</script>

<style>
.dropdown {
  position: relative;
}
</style>
